export class InputStatusDisp {
  constructor() {
    this.cellSize = 20;
    this.gap = 4;
    this.width = this.cellSize * 3 + this.gap * 2;
    this.height = this.cellSize * 2 + this.gap;
    this.colors = {
      neutral: "rgba(255, 255, 255, 0.95)",
      up: "rgba(36, 197, 94, 0.98)",
      side: "rgba(251, 146, 60, 0.98)",
    };

    this.element = document.createElement("div");
    this.element.style.position = "absolute";
    this.element.style.display = "grid";
    this.element.style.gridTemplateColumns = `repeat(3, ${this.cellSize}px)`;
    this.element.style.gridTemplateRows = `repeat(2, ${this.cellSize}px)`;
    this.element.style.gap = `${this.gap}px`;
    this.element.style.pointerEvents = "none";

    this.cells = [];
    for (let index = 0; index < 6; index += 1) {
      const cell = document.createElement("div");
      cell.style.width = `${this.cellSize}px`;
      cell.style.height = `${this.cellSize}px`;
      cell.style.border = "none";
      cell.style.boxShadow = "none";
      cell.style.background = "transparent";
      this.cells.push(cell);
      this.element.appendChild(cell);
    }

    this.upCell = this.cells[1];
    this.leftCell = this.cells[3];
    this.rightCell = this.cells[5];
    for (const controlCell of [this.upCell, this.leftCell, this.rightCell]) {
      controlCell.style.border = "1px solid rgba(255, 255, 255, 0.9)";
      controlCell.style.boxShadow = "0 0 1px rgba(0, 0, 0, 0.3)";
    }
    this.bottomMiddleCell = this.cells[4];
    this.bottomMiddleCell.style.border = "1px solid rgba(255, 255, 255, 0.9)";
    this.bottomMiddleCell.style.boxShadow = "0 0 1px rgba(0, 0, 0, 0.3)";
    this.invisibleCells = [this.cells[0], this.cells[2]];
    this.emptyCells = [this.cells[0], this.cells[2], this.cells[4]];
  }

  attach(parent, x, y) {
    this.setPosition(x, y);
    if (this.element.parentElement) {
      this.element.parentElement.removeChild(this.element);
    }
    parent.appendChild(this.element);
  }

  setPosition(x, y) {
    this.element.style.left = `${x}px`;
    this.element.style.top = `${y}px`;
  }

  setControlCellState(cell, isPressed, activeColor) {
    cell.style.background = isPressed ? activeColor : this.colors.neutral;
  }

  update({ upPressed = false, leftPressed = false, rightPressed = false } = {}) {
    if (!this.element.isConnected) {
      return;
    }
    for (const cell of this.emptyCells) {
      cell.style.background = "transparent";
    }
    for (const cell of this.invisibleCells) {
      cell.style.border = "none";
      cell.style.boxShadow = "none";
    }
    this.setControlCellState(this.upCell, upPressed, this.colors.up);
    this.setControlCellState(this.leftCell, leftPressed, this.colors.side);
    this.setControlCellState(this.rightCell, rightPressed, this.colors.side);
  }
}
